import { Flex, Layout, Spin } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { useEffect } from 'react';
import ReceiveNotify from 'src/components/v2/ReceiveNotify';
import TopicSider from 'src/pages/v2/Topic/TopicConversationBox/Sider';
import TopicGroup from 'src/pages/v2/Topic/TopicGroup';
import Topic from 'src/pages/v2/Topic/Topics';
import { useHasHydrated, useIsInitialized, useChatStore } from 'src/stores/chatStore';
import './TopicLayout.scss';

interface Props {
  children?: React.ReactNode;
}

export default function TopicLayout({ children }: Props) {
  const hasHydrated = useHasHydrated();
  const isInitialized = useIsInitialized();
  const restoreFromIndexedDB = useChatStore((state) => state.restoreFromIndexedDB);

  // ✅ Initialize IndexedDB restore on mount
  useEffect(() => {
    const initializeApp = async () => {
      if (!hasHydrated && !isInitialized) {
        console.log('🚀 TopicLayout: Starting IndexedDB restore...');
        try {
          await restoreFromIndexedDB();
        } catch (error) {
          console.error('❌ TopicLayout: IndexedDB restore failed:', error);
        }
      }
    };

    initializeApp();
  }, [restoreFromIndexedDB, hasHydrated, isInitialized]);

  if (!hasHydrated) {
    return (
      <div
        className='topic-layout-loading'
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: '#f5f5f5'
        }}
      >
        <Spin size='large' />
        <div style={{ marginTop: 16, color: '#666' }}>💾 Khôi phục dữ liệu...</div>
      </div>
    );
  }

  if (!isInitialized) {
    return (
      <div
        className='topic-layout-loading'
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: '#f5f5f5'
        }}
      >
        <Spin size='large' />
        <div style={{ marginTop: 16, color: '#666' }}>🚀 Đang khởi tạo...</div>
      </div>
    );
  }

  return (
    <div id='topic-layout'>
      <ReceiveNotify>
        <Flex>
          <TopicGroup />
          <Topic />
          <Layout>
            <Content>{children}</Content>
            <TopicSider />
          </Layout>
        </Flex>
      </ReceiveNotify>
    </div>
  );
}
